export default function Button({ children, onClick, className, disabled, style, bgClass }: { children: any; onClick?: () => void; className?: string; disabled?: boolean; style?: React.CSSProperties; bgClass?: string }) {
  const bg = disabled ? 'bg-gray-200 dark:bg-gray-700 text-gray-400 dark:text-gray-500 dark:text-gray-400' : (bgClass ? bgClass : 'bg-primary text-white');
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={style}
      className={
        `px-3 py-2 rounded-lg text-sm font-medium ${bg} ` +
        (className || '')
      }
    >
      {children}
    </button>
  );
}
